import { toast } from "sonner";

type OperationSuccessInput = {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
};

export function showOperationSuccess({ title, description, actionLabel, onAction }: OperationSuccessInput) {
  toast.success(title, {
    description,
    ...(actionLabel && onAction ? { action: { label: actionLabel, onClick: onAction } } : {}),
  });
}
